import { NotesTab } from '../../patient-files/notes/NotesTab';

/**
 * Patient notes panel for the work-queue task sidebar: full CRUD (create, pin,
 * edit, delete) with compact presentation. Delegates entirely to NotesTab;
 * modals render as fixed overlays and escape the sidebar card cleanly.
 */
export function WorkQueueNotesPanel({ patientId }: { patientId: string }) {
    return <NotesTab patientId={patientId} compact />;
}
